import { $root } from './model'

// Protobuf message models
// @ts-ignore
//export const Response = $root['Response']
// @ts-ignore
export const ResponseBatch = $root['ResponseBatch']
// @ts-ignore
//export const Request = $root['Request']
// @ts-ignore
export const RequestBatch = $root['RequestBatch']
// @ts-ignore
//export const IncomingMessagesRequest = $root['In/comingMessagesRequest']
// @ts-ignore
export const IncomingMessage = $root['IncomingMessage']
// @ts-ignore
export const Receiver = $root['Receiver']
